import { WaypointActionType } from '@caresend/types';

const durationsByWaypointActionType = {
    [WaypointActionType.PICKUP]: 15,
    [WaypointActionType.DROPOFF]: 5,
    [WaypointActionType.PATIENT_ACTION]: 45,
    [WaypointActionType.MAIL_IN]: 5,
    [WaypointActionType.SAMPLE]: 0,
};

export { durationsByWaypointActionType };
